import './App.css';
import DetailedResults from './components/DetailedResults';
import KeyCandidates from './components/KeyCandidates';
import MainResults from './components/MainResults';

function App() {
  return (
    <div className="App">
      <MainResults />
      <DetailedResults />
      <KeyCandidates />
    </div>
  );
}

export default App;
